/**
 * Created by richardlovejoy on 2/14/17.
 */

import {addVectors, subtractVectors, m4} from '../utils/math/m4';

import {MachineConstants, viewToPhysics, viewPositionToPhysics, physicsPositionToView} from '../constants/MachineConstants';
import SkeeballPhysics from './SkeeballPhysics';
import GameSounds from '../sound/GameSounds';

require('es6-object-assign').polyfill();


// create some scratch vectors so we don't have to create these each frame
const scratch1 = {x: 0, y: 0, z: 0};
const scratch2 = {x: 0, y: 0, z: 0};
const scratch3 = {x: 0, y: 0, z: 0};
const scratch4 = {x: 0, y: 0, z: 0};

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const Ball = function(game, options) {

  Phaser.Group.call(this, game);

  this.name = "Ball";
  this.id = 1+Math.floor(Math.random() *100);

  this.visible = false;


  // initial props
  this._state = Ball.STATE_PRE_BIRTH;
  this._color = Ball.BROWN_COLOR;
  this._sceneTHREE = options.sceneTHREE;
  this._scenePhantom = options.scenePhantom;
  this._obj3D = {
    position: {x: 0, y: 0, z: 0},
    THREE: null,
    phantom: null,
    scratch1: {x: 0, y: 0, z: 0},
    scratch2: {x: 0, y: 0, z: 0},
  };
  this._physic = null;
  this._arcadePhysics = {
    flatVelocity: {x: 0, y: 0, z: 0},  // unit vector velocity on the ramp or in the dispenser chute
    velocity: {x: 0, y: 0, z: 0, length: function() {
      return Math.sqrt(this.x*this.x + this.y*this.y + this.z*this.z);
    }},
    position: {x: 0, y: 0, z: 0}
  };
  this._rollFrame = 0;
  this._rollFrameTime = 0;
  this._dispenseDelay = 0;
  this._dispenseRestPos = {x: 0, y: 0, z: 0};
  this._cockRestPos = {x: 0, y: 0, z: 0};
  this._cupDepthZone = -1;
  this._canLaunch = false;
  this._launchTime = 0;


  // signals we send
  this.onSignalRolledBack = new Phaser.Signal();
  this.onSignalFellThroughHole = new Phaser.Signal();
  this.onSignalCupDepthZoneChanged = new Phaser.Signal();
  this.onSignalLaunchTimeout = new Phaser.Signal();

  // create state update functions
  if (!Ball.stateUpdaters) {
    Ball.stateUpdaters = [
      Ball.prototype._updatePreBirthState,
      Ball.prototype._updateDispensingState,
      Ball.prototype._updateIdleState,
      Ball.prototype._updatePreThrowState,
      Ball.prototype._updateRollingState,
      Ball.prototype._updateLaunchedState,
      Ball.prototype._updateLaunchedState
    ];
  }


  this.init();

};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const mc = MachineConstants;
const rcos = Math.cos(mc.FRONT_RAMP_SLOPE);
const rsin = Math.sin(mc.FRONT_RAMP_SLOPE);
const brcos = Math.cos(mc.BACK_RAMP_SLOPE);
const brsin = Math.sin(mc.BACK_RAMP_SLOPE);

Ball.BROWN_COLOR = 'brown';
Ball.RED_COLOR = 'red';
Ball.BLUE_COLOR = 'blue';

Ball.STATE_PRE_BIRTH = 0;
Ball.STATE_DISPENSING = 1;
Ball.STATE_IDLE = 2;
Ball.STATE_PRE_THROW = 3;
Ball.STATE_ROLLING = 4;
Ball.STATE_LAUNCHED = 5;
Ball.STATE_DROPPING_THROUGH = 6;

Ball.FRONT_RAMP_SLOPE_MATRIX = m4.xRotation(mc.FRONT_RAMP_SLOPE);
Ball.LAUNCH_RAMP_SLOPE_MATRIX = m4.xRotation(mc.LAUNCH_RAMP_SLOPE);
Ball.BACK_RAMP_SLOPE_MATRIX = m4.xRotation(-mc.BACK_RAMP_SLOPE);

Ball.LAUNCH_TIMEOUT = 6000;

// Cup positions rotated down to xz axis
const makeFlatCupPosition = function(cupPos) {

  const vex = subtractVectors(cupPos, mc.BALL_CUP_CHECK_POINT);
  return addVectors(mc.BALL_CUP_CHECK_POINT, m4.vectorMultiply(vex, Ball.BACK_RAMP_SLOPE_MATRIX));
};

// innerZone = depth zone when inside a cup - can be a number or array (for large center cup)
// outerZone = depth zone when outside a cup and 'behind' it (z < mid-point)
Ball.CUP_DEPTH_SORTING_DATA = [
  {xzPos: makeFlatCupPosition(mc.CENTER_CUP), height: mc.CUP_HEIGHT, radius: mc.CENTER_CUP_RADIUS, innerZone: 4},
  {xzPos: makeFlatCupPosition(mc.CENTER_UPPER_CUP), height: mc.CUP_HEIGHT, radius: mc.CENTER_UPPER_CUP_RADIUS, innerZone: 3},
  {xzPos: makeFlatCupPosition(mc.LARGE_CENTER_CUP), height: mc.CUP_HEIGHT, radius: mc.LARGE_CENTER_CUP_RADIUS, innerZone: [3, 5]},
  {xzPos: makeFlatCupPosition(mc.MIDDLE_TOP_CUP), height: mc.CUP_HEIGHT, radius: mc.MIDDLE_TOP_CUP_RADIUS, innerZone: 1, outerZone: 0},
  {xzPos: makeFlatCupPosition(mc.LEFT_TOP_CUP), height: mc.CUP_HEIGHT, radius: mc.CENTER_UPPER_CUP_RADIUS, innerZone: 1, outerZone: 0},
  {xzPos: makeFlatCupPosition(mc.RIGHT_TOP_CUP), height: mc.CUP_HEIGHT, radius: mc.CENTER_UPPER_CUP_RADIUS, innerZone: 1, outerZone: 0},
  {xzPos: makeFlatCupPosition(mc.BIG_RING), height: mc.CUP_HEIGHT, radius: mc.BIG_RING_RADIUS, innerZone: [2, 6]}
];

/*
[
  1, 0, 0, 0,
  0, 0.9981176853179932, 0.061327267438173294, 0,
  0, -0.061327267438173294, 0.9981176853179932, 0,
  0, 0, 0, 1
];
*/
Ball.RAMP_GRAVITY_FORCE = rsin*SkeeballPhysics.GRAVITY;
Ball.RAMP_GRAVITY = {x: 0, y: rsin*Ball.RAMP_GRAVITY_FORCE, z: -rcos*Ball.RAMP_GRAVITY_FORCE};

Ball.SKEW_ANGLE = 14 * Math.PI/180;
Ball.SHADOW_OFFSET = 50;

Ball.LEFT_BOUND = MachineConstants.LEFT_RAMP_WALL.x+MachineConstants.BALL_RADIUS;
Ball.RIGHT_BOUND = MachineConstants.RIGHT_RAMP_WALL.x-MachineConstants.BALL_RADIUS;
Ball.BOTTOM_BOUND = MachineConstants.FRONT_RAMP_END-MachineConstants.BALL_RADIUS;
Ball.TOP_BOUND = MachineConstants.FRONT_RAMP_END-MachineConstants.BALL_RADIUS*4;

// used to compute y placement on ramp after falling back
Ball.RAMP_Z_DISTANCE = (MachineConstants.THROW_START_BALL_PLACEMENT.z-MachineConstants.LAUNCH_RAMP_START);
Ball.RAMP_Y_DISTANCE = rsin*rcos/Ball.RAMP_Z_DISTANCE;
Ball.RAMP_Y_TOP = MachineConstants.THROW_START_BALL_PLACEMENT.y + Ball.RAMP_Y_DISTANCE;
Ball.RAMP_RATIO = Ball.RAMP_Y_DISTANCE/Ball.RAMP_Z_DISTANCE;

Ball.COLOR_FRAMES = {
  'brown': 'ball001.png',
  'red': 'ballBns001.png',
  'blue': 'ballDns001.png'
};

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
Ball.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: Ball,

  /**
   *
   */
  init: function () {

    // add visuals
    this.shadow = this.game.add.image(0, Ball.SHADOW_OFFSET, 'skee', 'ballShadow.png', this);
    this.shadow.anchor.set(0.5);

    this.ball = this.game.add.image(0, 0, 'skee', 'ball001.png', this);
    this.ball.anchor.set(0.5);

    // roll frames
    this.rolling = this.game.add.image(0, 0, 'skee', 'ballRoll_000.png', this);
    //this.rolling.blendMode = PIXI.blendModes.ADD;
    this.rolling.alpha = 0.25;
    this.rolling.anchor.set(0.5);

    this.highlight = this.game.add.image(0, 0, 'skee', 'ballHighlight.png', this);
    this.highlight.anchor.set(0.5);

    // add it to the 3d scene
    if (this._sceneTHREE) {
      this._obj3D.THREE = this._sceneTHREE.addBall(this._obj3D.position, MachineConstants.BALL_RADIUS);
    }
    if (this._scenePhantom) {
      this._obj3D.phantom = this._scenePhantom.addBall(this._obj3D.position, MachineConstants.BALL_RADIUS);
    }

  },

  inUse: function() {
    return (this._state !== Ball.STATE_PRE_BIRTH);
  },

  inDispenser: function() {
    return (this._state === Ball.STATE_DISPENSING || this.idle());
  },

  dispensing: function() {
    return (this._state === Ball.STATE_DISPENSING);
  },

  idle: function() {
    return (this._state === Ball.STATE_IDLE);
  },

  kill: function() {

    // remove physics body
    SkeeballPhysics.removeBall(this._physic);

    // remove signal listeners
    this.onSignalRolledBack.removeAll();
    this.onSignalFellThroughHole.removeAll();

    // hide
    this.visible = false;

    // back to pre-
    this._state = Ball.STATE_PRE_BIRTH;

  },

  dispense: function(attributes, startPosition, restPosition, delay) {

    this._state = Ball.STATE_DISPENSING;

    // switch to arcade physics
    this._physic = this._arcadePhysics;

    // set color
    this._color = attributes.color;
    this.ball.frameName = Ball.COLOR_FRAMES[this._color];

    // other attributes (ie .color)
    this._attributes = attributes;

    // dispense props
    this._dispenseDelay = delay;

    // set physics position
    viewPositionToPhysics(startPosition, this._physic.position);

    // zero out velocity
    Object.assign(this._physic.velocity, {x: 0, y: 0, z: 0});

    // resting position in view coords
    Object.assign(this._dispenseRestPos, restPosition);

  },

  ready: function() {

    // move to center
    const pos = this._obj3D.position;
    const placement = MachineConstants.THROW_START_BALL_PLACEMENT;

    const tw1 = this.game.add.tween(pos).to({x: [(placement.x+pos.x) * 0.7, placement.x], y: [placement.y+2, placement.y], z: [placement.z, placement.z]}, 600, Phaser.Easing.Quartic.Out, true);
    tw1.interpolation((v, k) => Phaser.Math.bezierInterpolation(v, k));

    tw1.onComplete.add(() => {

      // ready for throw
      this.preThrow();

    });

    Object.assign(this._cockRestPos, MachineConstants.THROW_START_BALL_PLACEMENT);

  },

  preThrow: function() {

    // ball is sitting on the ramp, waiting for toss
    this._state = Ball.STATE_PRE_THROW;

    // clear depth zone
    this._cupDepthZone = -1;

    // allow launch
    this._canLaunch = true;

    // fix shadow
    this._fixShadow();
  },

  bumpDown: function(restPosition) {

    // called when a ball is taken from the dispenser and other balls need to slide down
    Object.assign(this._dispenseRestPos, restPosition);

    // go
    this._state = Ball.STATE_DISPENSING;
  },

  roll: function($angle, power) {

    // skew for perspective - when ball is closer to edges a straight up throw actually has left/right velocity
    var theta = Ball.SKEW_ANGLE * (this._obj3D.position.x - 0) / Ball.RIGHT_BOUND;
    var angle = $angle - theta;

    /*
    // rotate vector according to skew
    var cs = Math.cos(theta);
    var sn = Math.sin(theta);

    // toss
    const velx = ($velx * cs - $velz * sn);
    const velz = ($velx * sn + $velz * cs);
    */

    // if angle of throw is 'close enough to 0', make it 0
    let scaledAngle = (angle-Math.PI/2) * 0.5;
    if (Math.abs(scaledAngle) < 0.05) {
      scaledAngle = 0;
    }
    const velx = -Math.sin(scaledAngle);
    const velz = -Math.cos(scaledAngle);

    // reset physics
    var physic = this._arcadePhysics;
    viewPositionToPhysics(this._obj3D.position, physic.position);

    // get the 3d velocity up the ramp
    physic.flatVelocity.x = velx * power;
    physic.flatVelocity.z = velz * power;
    m4.vectorMultiply(physic.flatVelocity, Ball.FRONT_RAMP_SLOPE_MATRIX, physic.velocity);

    //console.log('startBall vel:', physic.flatVelocity, scaledAngle);

    // start cannon physics mode
    // pop it - rotate normalized velocity in angle of slope
    this._physic = SkeeballPhysics.startBall(this._arcadePhysics.position, physic.velocity, 0.92*viewToPhysics(MachineConstants.BALL_RADIUS), MachineConstants.BALL_WEIGHT);

    // ramp sound
    this.game.soundManager.playSound(GameSounds.SOUND_HIT_RAMP);

    this._state = Ball.STATE_ROLLING;
  },

  followThrough: function(power) {

    // add more power along current path of velocity
    if (this._state !== Ball.STATE_ROLLING)
      return;

    SkeeballPhysics.pushBall(this._physic, power);
  },

  drop: function() {

    // turn off physics and just drop under
    this._physic.collisionFilterMask = 0;
    this._state = Ball.STATE_DROPPING_THROUGH;

    setTimeout(() => {

      this.onSignalFellThroughHole.dispatch();
      this.kill();

    }, 290);

    return this.onSignalFellThroughHole;
  },

  frameUpdate: function(dt) {

    // update current state
    Ball.stateUpdaters[this._state].call(this, dt);

    // update scene ball
    if (this._sceneTHREE) {
      Object.assign(this._obj3D.THREE.position, this._obj3D.position);
    }
    if (this._scenePhantom) {
      Object.assign(this._obj3D.phantom.position, this._obj3D.position);
    }


  },

  render: function() {

    // called after 3d rendering has taken place
    if (this._scenePhantom) {

      var screenPos = this._obj3D.phantom.userData.screen;
      this.x = screenPos.x;
      this.y = screenPos.y;

      // apply scaling for distance shrinkage
      var scale = this._scenePhantom.camera.scaleFromScreen(screenPos);
      this.scale.set(scale);

    }
  },

  // pre-toss


  // state updaters
  _updatePreBirthState: function() {

  },

  _updateDispensingState: function(dt) {

    if (!this.visible) {

      this._dispenseDelay -= dt;
      if (this._dispenseDelay <= 0) {
        this._showAndRoll();
      }
      else
        return;
    }

    // continue rolling
    this._updateArcadePhysics();
    this._updateRollFrame(dt);
    
    // check hitting resting place
    var worldPos = this._obj3D.position;
    if (worldPos.z >= this._dispenseRestPos.z) {

      // stop
      this._arcadePhysics.velocity.y = 0;
      this._arcadePhysics.velocity.z = 0;

      // place in the resting place
      worldPos.z = this._dispenseRestPos.z;

      // now idle
      this._state = Ball.STATE_IDLE;
    }

  },

  _updateIdleState: function() {


  },

  _updatePreThrowState: function() {

    // move toward toss cock
    var dx = this._cockRestPos.x - this._obj3D.position.x;
    var dy = this._cockRestPos.y - this._obj3D.position.y;
    var dz = this._cockRestPos.z - this._obj3D.position.z;

    this._obj3D.position.x += dx * 0.1;
    this._obj3D.position.y += dy * 0.1;
    this._obj3D.position.z += dz * 0.1;


  },

  _updateRollingState: function(dt) {

    // set obj3 position from physics
    physicsPositionToView(this._physic.position, this._obj3D.position);

    // check wall collision
    var worldPos = this._obj3D.position;
    var physic = this._physic;
    /*
    if ((physic.velocity.x < 0 && worldPos.x < Ball.LEFT_BOUND) ||
      (physic.velocity.x > 0 && worldPos.x > Ball.RIGHT_BOUND)) {

      worldPos.x = (worldPos.x < 0) ? Ball.LEFT_BOUND : Ball.RIGHT_BOUND;
      physic.velocity.x = -physic.velocity.x*0.5;

    }
    */

    // update roll frame
    this._updateRollFrame(dt);

    // check for launch on steep ramp or roll back
    if (worldPos.z < MachineConstants.LAUNCH_RAMP_START && this._canLaunch) {

      // pop it - rotate normalized velocity in angle of slope
      var veln = m4.vectorMultiply(physic.velocity, Ball.LAUNCH_RAMP_SLOPE_MATRIX);

      // start cannon physics mode
      SkeeballPhysics.launchBall(this._physic, veln);
      this._state = Ball.STATE_LAUNCHED;
      this._canLaunch = false;
      this._launchTime = this.game.time.time;
    }
    else if (worldPos.z > MachineConstants.FRONT_RAMP_END) {

      // rest should be current position until user moves it
      Object.assign(this._cockRestPos, this._obj3D.position);
      this._cockRestPos.z -= MachineConstants.BALL_RADIUS;

      //
      this._ballRolledBack();

    }
    else if (worldPos.x < Ball.LEFT_BOUND-0.2 || worldPos.x > Ball.RIGHT_BOUND+0.2) {

      // case where ball gets stuck on top of wall
      SkeeballPhysics.nudgeBall(this._physic, (worldPos.x > 0) ? -1 : 1);
    }

  },

  _updateLaunchedState: function() {

    // set obj3 position from physics
    physicsPositionToView(this._physic.position, this._obj3D.position);

    // check if behind cups
    this._updateDepth();

    if (this._state === Ball.STATE_DROPPING_THROUGH)
      return;

    //console.log('...', this._obj3D.position);

    // bring it back to rolling state if it didn't go anywhere...
    var worldPos = this._obj3D.position;
    if (worldPos.z > MachineConstants.LAUNCH_RAMP_START && this._physic.velocity.y < 0) {

      // when we get to the top of the ramp, put it back into rolling mode
      this._state = Ball.STATE_ROLLING;

      // sound
      this.game.soundManager.playSound(GameSounds.SOUND_ROLL_DOWN);

    }
    else if (worldPos.y < MachineConstants.BALL_CUP_CHECK_POINT.y) {

      if (worldPos.x < Ball.LEFT_BOUND-0.1 || worldPos.x > Ball.RIGHT_BOUND+0.1) {

        // case where ball gets stuck on top of wall
        SkeeballPhysics.nudgeBall(this._physic, (worldPos.x > 0) ? -1 : 1);

      }

    }

    // shadow limit
    if (worldPos.z > MachineConstants.BALL_CUP_CHECK_POINT.z) {

      // fix shadow
      this._fixShadow();

    }


    // check for timeout
    if (this.game.time.time - this._launchTime > Ball.LAUNCH_TIMEOUT) {

      this.onSignalLaunchTimeout.dispatch();

      // move back to rest
      Object.assign(this._cockRestPos, MachineConstants.THROW_START_BALL_PLACEMENT);

      // clean up
      this._ballRolledBack();
    }

  },

  // helpers
  _ballRolledBack: function() {

    // remove physics body
    SkeeballPhysics.removeBall(this._physic);

    // restart throw state
    this.onSignalRolledBack.dispatch();


    this.preThrow();

  },

  _showAndRoll: function() {

    this.visible = true;
    if (this._obj3D.THREE) {
      this._obj3D.THREE.visible = true;
    }

  },

  _updateArcadePhysics: function() {

    // compute velocity on ramp
    var physic = this._arcadePhysics;

    // move it
    var dt = this.game.time.elapsedSeconds;
    var physicsPos = physic.position;
    physicsPos.x += physic.velocity.x * dt;
    physicsPos.y += physic.velocity.y * dt;
    physicsPos.z += physic.velocity.z * dt;

    // gravity force
    physic.velocity.y += Ball.RAMP_GRAVITY.y * dt;
    physic.velocity.z += Ball.RAMP_GRAVITY.z * dt;

    // get world position
    physicsPositionToView(physicsPos, this._obj3D.position);
  },

  _updateDepth: function() {

    // short hand
    const radius = MachineConstants.BALL_RADIUS;

    // get position vector relative to a point near the start of cups
    var pos = this._obj3D.position;
    var vec = scratch1;
    var check = MachineConstants.BALL_CUP_CHECK_POINT;
    vec.x = pos.x - check.x;
    vec.y = pos.y - check.y;
    vec.z = pos.z - check.z;

    // get y relative to top of cups by rotating vec down to the xz plane
    var flatPos = m4.vectorMultiply(vec, Ball.BACK_RAMP_SLOPE_MATRIX, scratch2);
    flatPos.x += check.x;
    flatPos.y += check.y;
    flatPos.z += check.z;

    // if we're low enough, hide
    if (this._state === Ball.STATE_DROPPING_THROUGH && flatPos.y < check.y+MachineConstants.CUP_HEIGHT/2) {
      this.visible = false;
      return;
    }

    // check for intersection with cups
    let newZone = -1;
    Ball.CUP_DEPTH_SORTING_DATA.every(cupData => {

      // too high?
      if (flatPos.y-radius > cupData.xzPos.y+cupData.height/2) {
        return true;
      }

      // if ball is inside the cup, put it behind that cup
      let dx = flatPos.x-cupData.xzPos.x;
      let dz = flatPos.z-cupData.xzPos.z;
      var rsqrd = cupData.radius*cupData.radius;
      var dsqrd = dx*dx + dz*dz;
      if (dsqrd < rsqrd) {

        // if innerZone is array, check for back/front
        if (cupData.innerZone instanceof Array) {
          newZone = (flatPos.z+radius < cupData.xzPos.z) ? cupData.innerZone[0] : cupData.innerZone[1];
        }
        else {
          newZone = cupData.innerZone;
        }

        return false; // break
      }

      // check if ball is 'behind' the cup and below the cup top
      if (typeof cupData.outerZone !== 'undefined' && flatPos.y-radius < cupData.xzPos.y) {

        // only top cups need this...
        if (flatPos.z < cupData.xzPos.z) {
          newZone = cupData.outerZone;
        }
      }
      return true;
    });

    if (newZone != this._cupDepthZone) {

      this._cupDepthZone = newZone;
      this.onSignalCupDepthZoneChanged.dispatch(newZone);

    }
    //console.log('flat ', flat.z, vec);

    // we can use the flatPos.y to update the shadow...
    this.shadow.y = Ball.SHADOW_OFFSET + Math.max(0, flatPos.y*200);
    this.shadow.scale.set(Math.max(1, Math.min(2, 1 + (this.shadow.y - Ball.SHADOW_OFFSET) * 0.02)));
    this.shadow.alpha = 1/this.shadow.scale.x;
/*

 // get vector from bottom of ball to camera
 let cam = this._scenePhantom.camera;
 let dw = scratch1;
 dw.x = cam.x - pos.x;
 dw.y = cam.y - (pos.y+MachineConstants.BALL_RADIUS);
 dw.z = cam.z - pos.z;

 // rotate onto xz plane
 let d = scratch3;
 m4.vectorMultiply(dw, Ball.BACK_RAMP_SLOPE_MATRIX, d);


    float a = d.Dot( d ) ;
    float b = 2*f.Dot( d ) ;
    float c = f.Dot( f ) - r*r ;

    float discriminant = b*b-4*a*c;
    if( discriminant < 0 )
    {
      // no intersection
    }
    else
    {
      // ray didn't totally miss sphere,
      // so there is a solution to
      // the equation.

      discriminant = sqrt( discriminant );

      // either solution may be on or off the ray so need to test both
      // t1 is always the smaller value, because BOTH discriminant and
      // a are nonnegative.
      float t1 = (-b - discriminant)/(2*a);
      float t2 = (-b + discriminant)/(2*a);

      // 3x HIT cases:
      //          -o->             --|-->  |            |  --|->
      // Impale(t1 hit,t2 hit), Poke(t1 hit,t2>1), ExitWound(t1<0, t2 hit),

      // 3x MISS cases:
      //       ->  o                     o ->              | -> |
      // FallShort (t1>1,t2>1), Past (t1<0,t2<0), CompletelyInside(t1<0, t2>1)

      if( t1 >= 0 && t1 <= 1 )
      {
        // t1 is the intersection, and it's closer than t2
        // (since t1 uses -b - discriminant)
        // Impale, Poke
        return true ;
      }

      // here t1 didn't intersect so we are either started
      // inside the sphere or completely past it
      if( t2 >= 0 && t2 <= 1 )
      {
        // ExitWound
        return true ;
      }

      // no intn: FallShort, Past, CompletelyInside
      return false ;
    }
  */


  },

  _updateRollFrame: function(dt) {

    const direction = (this._physic.velocity.z < 0) ? 1 : -1;
    const speed = this._physic.velocity.length();
    const frm = this._rollFrame;
    this._rollFrameTime -= dt;

    if (this._rollFrameTime <= 0) {
      this.rolling.frameName = 'ballRoll_0'+(frm < 10 ? '0'+frm : frm)+'.png';

      let newFrame = this._rollFrame+direction;
      if (newFrame < 0) newFrame = 11+newFrame;
      this._rollFrame = newFrame % 11;
      this._rollFrameTime += Math.max(0.01, Math.min(0.3, 0.05/speed));
    }
    
  },
  
  _fixShadow: function() {

    this.shadow.y = Ball.SHADOW_OFFSET;
    this.shadow.alpha = 1;
    this.shadow.scale.set(1);

  },

  // cock/toss input responders
  moveBallToPointer: function(localPosition) {

    // find a world position for the ball and start cock motion
    var offx = (localPosition.x - this.x) * 0.014;
    var offz = (localPosition.y - this.y) * 0.02;

    // set cock rest position
    this._cockRestPos.x = Math.max(Ball.LEFT_BOUND, Math.min(Ball.RIGHT_BOUND, this._obj3D.position.x + offx));
    this._cockRestPos.z = Math.min(Ball.BOTTOM_BOUND, Math.max(Ball.TOP_BOUND, this._obj3D.position.z + offz));

    // calculate y move
    this._cockRestPos.y = this._obj3D.position.y - (this._cockRestPos.z-this._obj3D.position.z) * Ball.FRONT_RAMP_SLOPE_MATRIX[6]/Ball.FRONT_RAMP_SLOPE_MATRIX[5];

  },



});

Object.defineProperty(Ball.prototype, 'attributes', {
  get: function() {
    return this._attributes;
  },
  set: function(value) {
    this._attributes = value;
  }
});

Object.defineProperty(Ball.prototype, 'dispenseRestPosition', {
  get: function() {
    return this._dispenseRestPos;
  }
});

export default Ball;




// WEBPACK FOOTER //
// ./app/src/display/Ball.js